import avatar from './avatar-person.jpg';
import finePrint from './FinePrint.png';
import heyLogo from './HEY-logo@2x.png';
import iconBell from './icon-bell.png';
import iconCamera from './icon-camera.png';
import iconChecked from './icon-checked.png';
import iconClose from './icon-close.png';
import iconCloseWhite from './icon-close-white.png';
import iconSearch from './icon-search.png';
import iconUpload from './icon-upload.png';
import iconClock from './iconmonstr-clock-thin-24.png';
import iconEdit from './iconmonstr-edit-5.png';
import iconFavorite from './iconmonstr-favorite-1-24.png';
import iconComment from './iconmonstr-speech-bubble-comment-thin-24.png';
import reading from './Reading.png';
import strike from './Strike.png';
import trash from './trash.png';
import trial from './trial.jpg';
import yesilcam from './yesilcam.png';


export default {
avatar,
finePrint,
heyLogo,
iconBell,
iconCamera,
iconChecked,
iconClock,
iconClose,
iconCloseWhite,
iconComment,
iconEdit,
iconFavorite,
iconSearch,
iconUpload,
reading,
strike,
trash,
trial,
yesilcam
}